import React from "react";
import Helmet from "react-helmet";
import { REACT_APP_COLBI_THEME } from "../environmentVariables";
import { isNonProdEnviroment } from "../utils/utils";
import { camelize } from "../utils";

function HeadChange() {
    const environment = isNonProdEnviroment(window.location.origin);
    const environmentTitle = environment ? `[${environment.toUpperCase()}] - ` : "";
    return (
        <Helmet>
            <title>{`${environmentTitle}${camelize(REACT_APP_COLBI_THEME)}`}</title>
            <link rel="icon" type="image/png" href={`/sovos.png`} />
        </Helmet>
    );
}
export default HeadChange;
